import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Chip,
  Button,
  Grid,
  IconButton,
  Container,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import apiRequest from "../../Utils/apiRequest";
import { apiUrl } from "../../config";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GetAdvertDto } from "./type";
import { useTranslation } from "react-i18next";

const JobApplicationModal = () => {
  const [data, setData] = useState<GetAdvertDto>();
  let navigate = useNavigate();
  const { t } = useTranslation();

  const { id } = useParams();
  console.log("id", id);

  const parseHtmlContent = (html: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.body;
  };
  const renderHtmlContent = (html: string) => {
    const parsedContent = parseHtmlContent(html);
    return Array.from(parsedContent.childNodes).map((node, index) => {
      if (node.nodeName === "P") {
        return (
          <p key={index} style={{ marginBottom: "12px" }}>
            {node.textContent}
          </p>
        );
      }
      if (node.nodeName === "H2") {
        return (
          <h2 key={index} style={{ fontWeight: "bold", marginTop: "16px" }}>
            {node.textContent}
          </h2>
        );
      }
      if (node.nodeName === "UL") {
        return (
          <ul key={index} style={{ paddingLeft: "20px" }}>
            {Array.from(node.childNodes).map((listItem, idx) => (
              <li key={idx}>{listItem.textContent}</li>
            ))}
          </ul>
        );
      }
      return <span key={index}>{node.textContent}</span>;
    });
  };

  const getAnnoucmentData = async () => {
    try {
      const response = await apiRequest(
        "GET",
        `${apiUrl}Advert/getExternalEntity?Id=${id}`,
        ""
      );
      setData(response.data);
      console.log("response", response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAnnoucmentData();
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center", // Yatayda ortalama
        alignItems: "center", // Dikeyde ortalama
        backgroundColor: "#f5f5f5", // Arka plan rengi
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            maxWidth: "600px",
            margin: "1rem",
            padding: "20px",
            backgroundColor: "#FFFFFF",
            
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            position: "relative",
          }}
        >
          {/* <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
            İlan Başvurusu
          </Typography> */}
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
            {t("İlan Detayları")}
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
            {data?.createdAt
              ? new Date(data.createdAt).toLocaleDateString("tr-TR")
              : ""}
          </Typography>

          <Grid container spacing={2} display={"flex"} flexDirection={"column"}>
            <Grid item xs={12}>
              <TextField
                label={t("İlan Başlığı")}
                size="small"
                value={data?.jobDescription}
                InputLabelProps={{
                  shrink: data?.jobDescription ? true : false,
                }}
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                label={t("Çalışma Şekli")}
                InputLabelProps={{
                  shrink: data?.workingMethod ? true : false,
                }}
                value={data?.workingMethod}
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                size="small"
                label={t("Konum")}
                value={data?.province?.provinceName}
                InputLabelProps={{
                  shrink: data?.province.provinceName ? true : false,
                }}
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <Box>
                {/* Nitelikler Başlığı */}
                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    display: "flex",
                    justifyContent: "flex-start",
                    fontWeight: "bold", // Başlığı vurgulamak için
                    color: "text.primary", // Tema uyumu için
                  }}
                >
                  {t("Nitelikler")}
                </Typography>

                {/* Nitelikler Chip'leri */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexWrap: "wrap",
                    mb: 2, // Deneyim bölümüne boşluk bırakmak için
                  }}
                >
                  {data?.skills.map((skill, index) => (
                    <Chip
                      key={index} // Her chip için benzersiz bir key
                      label={skill}
                      color="primary"
                      variant="outlined"
                      sx={{
                        fontSize: "0.875rem", // Daha uyumlu bir yazı boyutu
                        borderRadius: "5px"
                      }}
                    />
                  ))}
                </Box>

                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    display: "flex",
                    justifyContent: "flex-start",
                    fontWeight: "bold",
                    color: "text.primary",
                  }}
                >
                  {t("Deneyim")}
                </Typography>

                <Chip
                  label={data?.experience}
                  sx={{
                    backgroundColor: "#F5F5F5",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    borderRadius: "5px",
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="body2"
                sx={{ mb: 1, display: "flex", justifyContent: "flex-start" }}
              >
                {t("İlan Açıklaması")}
              </Typography>
              <Box
                sx={{
                  border: "1px solid #E0E0E0",
                  
                  padding: "16px",
                }}
              >
                {renderHtmlContent(data?.description || "")}
              </Box>
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 4,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => navigate("/ilanlar")}
            >
              {t("İptal")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`/basvuruformu/${data?.id}`)}
            >
              {t("Başvur")}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default JobApplicationModal;
